var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CorporateNavigation", { attrs: { ActivePage: "strategy" } }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 text-right align-self-end" },
                  [
                    _vm.rm.Defaults
                      ? _c("div", { staticClass: "btn-group" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-outline-success dropdown-toggle",
                              staticStyle: { padding: "0.7em 2em" },
                              attrs: {
                                type: "button",
                                "data-toggle": "dropdown",
                              },
                            },
                            [_vm._v("Create P&L")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-menu dropdown-menu-right",
                            },
                            [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "sanitizedHref",
                                      rawName: "v-sanitizedHref",
                                      value: `/#/enterprise/pnls/create/${_vm.workspaceId}/${_vm.strategyId}`,
                                      expression:
                                        "`/#/enterprise/pnls/create/${workspaceId}/${strategyId}`",
                                    },
                                  ],
                                  staticClass: "dropdown-item",
                                },
                                [
                                  _vm._v(
                                    "\n                            Blank\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _vm._l(_vm.rm.Defaults, function (t) {
                                return _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "sanitizedHref",
                                        rawName: "v-sanitizedHref",
                                        value: `/#/enterprise/pnls/create/${_vm.workspaceId}/${_vm.strategyId}/${t.Id}`,
                                        expression:
                                          "`/#/enterprise/pnls/create/${workspaceId}/${strategyId}/${t.Id}`",
                                      },
                                    ],
                                    key: t.Id,
                                    staticClass: "dropdown-item",
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(t.Name) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr", {
                staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mt-3" }, [
                _c(
                  "table",
                  { staticClass: "table table-bordered table-hover" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.rm.Corporate, function (t) {
                        return _c("tr", { key: t.Id }, [
                          _c("td", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(t.Name) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("div", { staticClass: "dropdown" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary dropdown-toggle",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    Actions\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "sanitizedHref",
                                          rawName: "v-sanitizedHref",
                                          value: `/#/enterprise/pnls/edit/${_vm.workspaceId}/${_vm.strategyId}/${t.Id}`,
                                          expression:
                                            "`/#/enterprise/pnls/edit/${workspaceId}/${strategyId}/${t.Id}`",
                                        },
                                      ],
                                      staticClass: "dropdown-item",
                                    },
                                    [_vm._v("Edit")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDeletePnlCommand(
                                            t.Id
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Delete")]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
            margin: "0",
          },
        },
        [_vm._v("P&L templates")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "120px" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }